import { useState } from 'react';
import { faqs } from '@/mocks/gossip';
import SectionHead from './SectionHead';

export default function FaqSection() {
  const [openKey, setOpenKey] = useState<string | null>('faq1');

  return (
    <section id="wenda" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <SectionHead
              en="FAQ"
              title="吃瓜问答"
              desc="关于实锤、线索、核验流程与投稿的常见问题，帮助你更理性地看待每一份新证据。"
            />
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-question-mark" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">还是没找到答案？</p>
                  <p className="text-xs text-foreground-500">请通过底部联系方式或投稿入口反馈</p>
                </div>
              </div>
              <a
                href="#contact"
                className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-customer-service-2-line" />
                联系站务组
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="space-y-3">
              {faqs.map((item) => {
                const open = openKey === item.id;
                return (
                  <div
                    key={item.id}
                    className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                      open ? 'border-primary-300' : 'border-background-200'
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenKey(open ? null : item.id)}
                      aria-expanded={open}
                      className="flex w-full items-center gap-3 px-4 py-4 text-left md:px-5"
                    >
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${
                          open ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-900'
                        }`}
                      >
                        <i className={open ? 'ri-subtract-line' : 'ri-add-line'} />
                      </span>
                      <h3 className="flex-1 text-sm font-medium text-foreground-900 md:text-base">
                        {item.q}
                      </h3>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-4 pb-4 pl-14 text-sm leading-relaxed text-foreground-600 md:px-5 md:pl-14">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}